import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
const Features = () => {
  const [name, setName] = useState('');
  let navigate = useNavigate();
  const handleNameChange = e => {
    setName(e.target.value);
  };

  const redirectToLogin = () => {
    return navigate('./login/newUser/', { state: name })
  }

  return (
    <Box
      style={{ backgroundColor: '#53131E' }}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      id="learn-more"
    >
      <Container maxWidth="md">
        <Box xs={12} mt={5}>
          <Typography
            style={{ color: '#FAC9B8' }}
            align="center"
            color="textPrimary"
            variant="h1"
          >
            Features
          </Typography>
        </Box>
      </Container>
      <Container>
        <Grid container spacing={7}>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h2" gutterBottom>
                  Voiceover Recording.
                </Typography>
                <Typography variant="body2" component="p">
                  Record voiceovers on any phone, tablet, or computer. 
                </Typography>
                <Typography variant="body2" component="p">
                  Voicebot Research has found that not only do consumers prefer
                  human voices over synthetic in their voice experiences, but
                  the difference is 71.6% more.
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={redirectToLogin}>Get Started</Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h2" gutterBottom>
                  Earn Money
                </Typography>
                <Typography variant="body2" component="p">
                  Musicians earn more per listener on Voice platforms than any
                  of the major streaming platforms.
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={redirectToLogin}>Get Started</Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card>
              <CardContent>
                <Typography variant="h2" gutterBottom>
                  100% Free
                </Typography>
                <Typography variant="body2" component="p">
                  Be there first, make your mark, friction-free fan discovery on all smart speakers.
                </Typography>
                <Typography variant="body2" component="p">
                  49% of US households own a smart speaker or smart display.
                  Make fan discovery as easy as asking Alexa.
                </Typography>
                <Typography variant="body2" component="p">
                  Put your music & voice on Amazon Alexa quick, easy, and free. 
                  Why isn't your music already distributed on voice platforms?
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" onClick={redirectToLogin}>Get Started</Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Box mt={5}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={7}
          >
            <Grid item xs={12}>
              <Typography
                align="center"
                color="textPrimary"
                variant="h1"
                style={{ color: '#FAC9B8' }}
              >
                What's Your Stage Name?
              </Typography>
            </Grid>
            <Box m="auto">
              <TextField
                color="secondary"
                inputProps={{
                  style: { textAlign: 'center', color: '#FAC9B8' }
                }}
                InputLabelProps={{ style: { color: '#FAC9B8' } }}
                id="musician-name"
                label="Musician Name"
                style={{ color: '#FAC9B8' }}
                value={name}
                onChange={handleNameChange}
                variant="outlined"
                onKeyPress={ev => {
                  if (ev.key === 'Enter') {
                    ev.preventDefault();
                    return navigate('./login/newUser/', { state: name })
                  }
                }}
              />
            </Box>
            <Grid item container justify="center" alignItems="center">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  navigate('./login/newUser/', { state: name });
                }}
              >
                Get Started
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Features;
